import React, {Component} from 'react';
import {
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand,
  NavLink,
  Badge
} from 'reactstrap';
import { inject, observer } from "mobx-react";

@inject("userStore") @observer
class Header extends Component {

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {
    const { userStore } = this.props;
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <NavbarBrand href="/#/dashboard"></NavbarBrand>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/#/users/list">Users</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="/#/contractors/list-approved">Contractors</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="/#/projects/list-approved">Projects</NavLink>
          </NavItem>
          {/* <NavItem className="px-3">
            <NavLink href="/#/products/list">Products</NavLink>
          </NavItem> */}
        </Nav>
        <Nav className="ml-auto" navbar>
          
          <NavItem className="d-md-down-none" onClick={() => userStore.logout()}>
            <NavLink href="#">Xin chào: <strong>{userStore.userData.name || "Khách"}</strong> {
              !!userStore.userData.name ? "(Logout)" : ""
            }</NavLink>
          </NavItem>
        </Nav>
        <NavbarToggler className="d-md-down-none" onClick={this.asideToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js